import { render, staticRenderFns } from "./AddIdentifiedItemsToBin.vue?vue&type=template&id=a6566222&scoped=true"
import script from "./AddIdentifiedItemsToBin.vue?vue&type=script&lang=js"
export * from "./AddIdentifiedItemsToBin.vue?vue&type=script&lang=js"
import style0 from "./AddIdentifiedItemsToBin.vue?vue&type=style&index=0&id=a6566222&prod&scoped=true&lang=css"
import style1 from "./AddIdentifiedItemsToBin.vue?vue&type=style&index=1&id=a6566222&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6566222",
  null
  
)

export default component.exports